import produce from 'immer';
import { Reducer } from 'redux';

import { ICommentsActionsType, ICommentsTypes, ICommentsState } from './types';

const INITIAL_STATE: ICommentsState = {
  loading: false,
  commentsList: undefined,
};

const comments: Reducer<ICommentsState, ICommentsActionsType> = (
  state = INITIAL_STATE,
  action: ICommentsActionsType,
) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case ICommentsTypes.GET_TASK_COMMENTS_REQUEST: {
        draft.loading = true;
        draft.commentsList = undefined;
        break;
      }
      case ICommentsTypes.GET_TASK_COMMENTS_SUCCESS: {
        draft.loading = false;
        draft.commentsList = action.payload.comments;
        break;
      }
      case ICommentsTypes.GET_TASK_COMMENTS_FAILURE: {
        draft.loading = false;
        break;
      }
      case ICommentsTypes.COMMENT_TASK_COMMENTS_REQUEST: {
        draft.loading = true;
        break;
      }
      case ICommentsTypes.COMMENT_TASK_COMMENTS_SUCCESS: {
        draft.loading = false;
        draft.commentsList = action.payload.comments;
        break;
      }
      case ICommentsTypes.COMMENT_TASK_COMMENTS_FAILURE: {
        draft.loading = false;
        break;
      }
      case ICommentsTypes.UPDATE_TASK_COMMENT_REQUEST: {
        draft.loading = true;
        break;
      }
      case ICommentsTypes.UPDATE_TASK_COMMENT_SUCCESS: {
        draft.loading = false;
        draft.commentsList = action.payload.comments;
        break;
      }
      case ICommentsTypes.UPDATE_TASK_COMMENT_FAILURE: {
        draft.loading = false;
        break;
      }
      case ICommentsTypes.DELETE_TASK_COMMENT_REQUEST: {
        draft.loading = true;
        break;
      }
      case ICommentsTypes.DELETE_TASK_COMMENT_SUCCESS: {
        draft.loading = false;
        draft.commentsList = action.payload.comments;
        break;
      }
      case ICommentsTypes.DELETE_TASK_COMMENT_FAILURE: {
        draft.loading = false;
        break;
      }
      default:
    }
  });
};
export default comments;
